import { LocalShipping as LocalShippingIcon, DepartureBoard as DepartureBoardIcon, AccessTime as AccessTimeIcon,
  Article as ArticleIcon, CheckCircleOutline as CheckCircleOutlineIcon, PriceCheck as PriceCheckIcon,
} from '@mui/icons-material';

import { useScoreboardData } from '../../../hooks/reports/useScoreboardData';
import DynamicTable from '../../../components/tables/dynamicTable';
import StatCard from '../../../components/common/cards/StatCard';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import { useLocation } from 'react-router-dom';
import './scoreboard.css';

const Scoreboard = () => {
  const location = useLocation();
  const { reportName, reportId } = location.state || {};
  const { reportData, totals } = useScoreboardData(reportName);

  const getScoreColor = (score) => {
    if (score >= 90) return '#4CAF50';  // green
    if (score >= 80) return '#FF9800';  // orange
    return '#F44336';                   // red
  };

  return (
    <div className="scoreboardPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="scoreBoardContent">
          <div className="scoreBoardTitle">
            <h1>Carrier Scoreboard</h1>
          </div>
          <div className="scoreboardOverallScore">
            <span className="label">Total Score: </span>
            <span style={{ color: getScoreColor(totals?.TOTAL_SCORE) }}>
              {totals?.TOTAL_SCORE ? `${totals.TOTAL_SCORE}%` : '—'}
            </span>
          </div>
          <div className="scoreboardWidgetsContainer">
            <div className="scoreboardWidgets">
              <StatCard icon={LocalShippingIcon} label="Total Loads" value={totals?.TOTAL_LOADS}  />
              <StatCard icon={DepartureBoardIcon} label="Pickup OnTime" value={`${totals?.PERCENT_PICKUP_ON_TIME ?? '—'}%`} color={getScoreColor(totals?.PERCENT_PICKUP_ON_TIME)}  />
              <StatCard icon={AccessTimeIcon} label="Delivery OnTime" value={`${totals?.PERCENT_DELIVERY_ON_TIME ?? '—'}%`} color={getScoreColor(totals?.PERCENT_DELIVERY_ON_TIME)} />
              <StatCard icon={ArticleIcon} label="Has PODs" value={`${totals?.PERCENT_HAS_PODS ?? '—'}%`}  color={getScoreColor(totals?.PERCENT_HAS_PODS)}/>
              <StatCard icon={CheckCircleOutlineIcon} label="Damage Free" value={`${totals?.PERCENT_DAMAGE_FREE ?? '—'}%`} color={getScoreColor(totals?.PERCENT_DAMAGE_FREE)} />
              <StatCard icon={PriceCheckIcon} label="Quote Match" value={`${totals?.PERCENT_QUOTE_MATCH?? '—'}%`} color={getScoreColor(totals?.PERCENT_QUOTE_MATCH)} />
            </div>
          </div>
          <div className="scoreboardWeightWrapper">
            <div className="scoreboardWeightLegend">
              <div className="scoreboardLegendTitle">Weighted % by Category</div>
              <div className="scoreboardWeightGrid">
                <div><strong>On Time Pickup:</strong> 10%</div>
                <div><strong>On Time Delivery:</strong> 30%</div>
                <div><strong>PODs Uploaded:</strong> 10%</div>
                <div><strong>Damages:</strong> 20%</div>
                <div><strong>Billing Accuracy:</strong> 30%</div>
              </div>
            </div>
          </div>
          <div className="scoreBoardTable">
            <DynamicTable dataObject={reportData} showTotalRow={true} />
          </div>
          <div className="ScoreboardButtons"></div>
        </div>
      </div>
    </div>
  )
}

export default Scoreboard 